jQuery(document).ready(function ($) {

    const animationSingle = bodymovin.loadAnimation({
        container: document.getElementById('svg__01'),
        path: '/wp-content/themes/beaverwarrior/components/LottieAnimation/bw-lottie-animation/includes/img/IconFinalSize.json',
        autoplay: true,
        renderer: 'svg',
        loop: true
    });

});
